import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// Constants
import { errorColor, bodyColor } from "../../../../config/constants";
// Components
import {
  PersonalInformationDiv,
  TitleTextDiv,
  DataDiv,
  ColumnDataDiv,
  InputDataDiv,
  Label,
  Input,
  RelativeButton,
  InputBirthday,
  Textarea,
} from "./styles";
import Select from "../../../selectInput";
// Assets
import SelectArrow from "../../../../assets/ico_arrow_down.svg";
import VisiblePasswordImg from "../../../../assets/btn_visible_password.svg";
import HidePasswordImg from "../../../../assets/btn_hide_password.svg";

const PersonalInfo = ({
  login,
  setLogin,
  loginError,
  setLoginError,
  password,
  setPassword,
  passwordError,
  setPasswordError,
  gender,
  setGender,
  genderError,
  setGenderError,
  height,
  setHeight,
  heightError,
  setHeightError,
  dateOfBirth,
  setDateOfBirth,
  dateOfBirthError,
  setDateOfBirthError,
  gameExperience,
  setGameExperience,
  computerExperience,
  setComputerExperience,
  otherInfo,
  setOtherInfo,
  pareticSide,
  setPareticSide,
  pareticSideError,
  setPareticSideError,
}) => {
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [t] = useTranslation("global");

  const handleSetPasswordVisibility = (e) => {
    e.preventDefault();
    setVisiblePassword(!visiblePassword);
  };

  const handleSetInput = (e, setInput, setError) => {
    setInput(e.target.value);
    if (setError) setError(false);
  };

  return (
    <PersonalInformationDiv>
      <TitleTextDiv>
        <p>{t("personalInformation.title")}</p>
      </TitleTextDiv>
      <DataDiv>
        <ColumnDataDiv>
          <InputDataDiv>
            <Label htmlFor="login" fontWeight="bold">
              {t("personalInformation.userNameLabel")} *
            </Label>
            <Input
              type="text"
              placeholder={t("personalInformation.userNameInput")}
              id="login"
              value={login}
              onChange={(e) => handleSetInput(e, setLogin, setLoginError)}
              error={loginError}
            />
          </InputDataDiv>
          <InputDataDiv>
            <Label htmlFor="password" fontWeight="bold">
              {t("personalInformation.passwordLabel")} *
            </Label>
            <Input
              type={visiblePassword ? "text" : "password"}
              placeholder="*******"
              id="password"
              value={password}
              onChange={(e) => handleSetInput(e, setPassword, setPasswordError)}
              error={passwordError}
              padding="5px 32px 5px 10px"
            />
            <RelativeButton onClick={handleSetPasswordVisibility}>
              <img src={visiblePassword ? HidePasswordImg : VisiblePasswordImg} alt="icon-password-button" />
            </RelativeButton>
          </InputDataDiv>
          <InputDataDiv>
            <Label fontWeight="bold">{t("patientGender.label")} *</Label>
            <Select
              value={gender}
              onChange={(e) => handleSetInput(e, setGender, setGenderError)}
              padding="5px 35px 5px 10px"
              width="200px"
              arrowImg={SelectArrow}
              backgroundPosition="175px center"
              error={genderError}
            >
              <option value=""></option>
              <option value="MALE">{t("patientGender.male")}</option>
              <option value="FEMALE">{t("patientGender.female")}</option>
            </Select>
          </InputDataDiv>
          <InputDataDiv>
            <Label htmlFor="height" fontWeight="bold">
              {t("personalInformation.heightLabel")} *
            </Label>
            <Input
              type="number"
              placeholder="175"
              id="height"
              value={height}
              onChange={(e) => handleSetInput(e, setHeight, setHeightError)}
              error={heightError}
            />
          </InputDataDiv>
          <InputDataDiv>
            <Label htmlFor="dateOfBirth" fontWeight="bold">
              {t("personalInformation.birthdayLabel")} *
            </Label>
            <InputBirthday
              format="##/##/####"
              placeholder="dd/mm/yyyy"
              mask={["d", "d", "m", "m", "y", "y", "y", "y"]}
              value={dateOfBirth}
              onChange={(e) => handleSetInput(e, setDateOfBirth, setDateOfBirthError)}
              error={dateOfBirthError ? `1px solid ${errorColor}` : `1px solid ${bodyColor}`}
            />
          </InputDataDiv>
          <InputDataDiv>
            <Label fontWeight="bold">{t("pathologyInformation.pareticSideLabel")} *</Label>
            <Select
              value={pareticSide}
              onChange={(e) => handleSetInput(e, setPareticSide, setPareticSideError)}
              padding="5px 35px 5px 10px"
              width="200px"
              arrowImg={SelectArrow}
              backgroundPosition="175px center"
              error={pareticSideError}
            >
              <option value=""></option>
              <option value="LEFT">{t("pathologyInformation.pareticSideSelect.left")}</option>
              <option value="RIGHT">{t("pathologyInformation.pareticSideSelect.right")}</option>
            </Select>
          </InputDataDiv>
        </ColumnDataDiv>
        <ColumnDataDiv>
          <InputDataDiv>
            <Label>{t("personalInformation.videoGameExperienceLabel")}</Label>
            <Select
              value={gameExperience}
              onChange={(e) => setGameExperience(e.target.value)}
              padding="5px 35px 5px 10px"
              width="200px"
              arrowImg={SelectArrow}
              backgroundPosition="175px center"
            >
              <option value={null}>{t("personalInformation.no")}</option>
              <option value={1}>{t("personalInformation.yes")}</option>
            </Select>
          </InputDataDiv>
          <InputDataDiv>
            <Label>{t("personalInformation.computerExperienceLabel")}</Label>
            <Select
              value={computerExperience}
              onChange={(e) => setComputerExperience(e.target.value)}
              padding="5px 35px 5px 10px"
              width="200px"
              arrowImg={SelectArrow}
              backgroundPosition="175px center"
            >
              <option value={null}>{t("personalInformation.no")}</option>
              <option value={1}>{t("personalInformation.yes")}</option>
            </Select>
          </InputDataDiv>
          <InputDataDiv>
            <Label htmlFor="comment">{t("personalInformation.otherInformationLabel")}</Label>
            <Textarea id="comment" value={otherInfo} onChange={(e) => setOtherInfo(e.target.value)} />
          </InputDataDiv>
        </ColumnDataDiv>
      </DataDiv>
    </PersonalInformationDiv>
  );
};

export default PersonalInfo;
